import { Alert, Form, Modal, Typography } from 'antd';
import { useState } from 'react';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import PdfViewer from '../../components/PdfViewer';
import {
  generalCertificatesContractTable,
  generalCertificatesOrganizations,
  generalCertificatesTable,
  getGeneral as getGeneralUrl,
  postGeneral as createGeneralCertificate,
} from '../../api/module/ct_certifications_contractor';
import { AjaxTable, CustomButton, CustomSelector } from '../../components';
import { catchExceptionSRate } from '../../utils/helpers/helpers';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;
const breadcrumbItems = [
  {
    text: 'Certificaciones',
    to: INTERNAL_LINKS.CONTRACTOR_CT_CERTIFICATIONS,
  },
  {
    text: 'Certificaciones generales',
  },
];

const AddModal = ({ open, onFinish, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  async function onSelfFinish(data) {
    try {
      setLoading(true);
      await onFinish(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  const columns = [
    {
      title: 'No. Contrato',
      dataIndex: 'contrato_num',
      width: '7em',
      align: 'center',
    },
    {
      title: 'Cargo',
      dataIndex: 'rol',
    },
  ];

  if (!open) return null;
  return (
    <Modal
      open={true}
      footer={
        <CustomButton
          onClick={() => form.submit()}
          text="Generar"
          loading={loading}
        />
      }
      styles={{ footer: { display: 'flex', justifyContent: 'center' } }}
      title="Generación de Certificación general"
      onCancel={onCancel}
      width={'80%'}
    >
      <Form
        form={form}
        onFinish={onSelfFinish}
        layout="vertical"
        requiredMark={false}
        preserve={false}
      >
        <Form.Item
          label="Por favor seleccione la entidad contratante de la cual requiere la certificación"
          name="organizacion"
          valuePropName="initialValue"
          rules={[{ required: true, message: 'Requerido' }]}
        >
          <CustomSelector endpointFetch={generalCertificatesOrganizations} />
        </Form.Item>
        <Text>
          La certificación generada mostrará los siguientes datos:{' '}
          <b>Estado del contrato, Objeto, Duración, Valor y Obligaciones</b>
        </Text>
        <br />
        <Text>
          Estos son los contratos que se incluirán en la certificación a generar
        </Text>
        <Form.Item noStyle dependencies={['organizacion']}>
          {({ getFieldValue }) => {
            const org = getFieldValue('organizacion');
            if (!org) return null;
            return (
              <AjaxTable
                columns={columns}
                scroll={{ x: false }}
                endpoint={generalCertificatesContractTable}
                query={{
                  organizacion: org,
                }}
              />
            );
          }}
        </Form.Item>
      </Form>
    </Modal>
  );
};

const CTGeneralCertificationsContractor = () => {
  const [reloadSource, setReloadSource] = useState(false);
  const [loadingUrl, setLoadingUrl] = useState(false);
  const [pdfUrl, setPDFUrl] = useState();
  const [formOpen, setFormOpen] = useState(false);

  const onOpenForm = () => {
    setFormOpen(true);
  };

  const onFinish = async (data) => {
    try {
      await createGeneralCertificate(data);
      setReloadSource({});
      setFormOpen(false);
    } catch (error) {
      catchExceptionSRate(error);
    }
  };

  async function getPdfURL(id) {
    try {
      setLoadingUrl(true);
      const { data: dataUrl } = await getGeneralUrl(id);
      setPDFUrl(dataUrl.url);
    } catch (error) {
      catchExceptionSRate(error);
    } finally {
      setLoadingUrl(false);
    }
  }

  const columns = [
    {
      title: 'Fecha de generación',
      dataIndex: 'fecha',
    },
    {
      title: 'Entidad contratante',
      dataIndex: 'organizacion_nombre',
    },
    {
      key: 'acciones',
      title: 'Acciones',
      width: '10em',
      render: (_, record) =>
        record.estado_firma === 4 ? (
          <CustomButton
            text="Visualizar"
            type="default"
            htmlType="button"
            block
            onClick={() => getPdfURL(record.id)}
            loading={loadingUrl}
          />
        ) : (
          'Generación en proceso'
        ),
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        CERTIFICACIONES GENERALES
      </Title>
      <Alert
        type="info"
        showIcon
        message="Información importante"
        description={
          <>
            <Text>
              A continuación se muestra el listado de certificaciones generales
              disponibles para su visualización. En caso de requerir una nueva
              certificación por favor de clic en "Generar nuevo certificado"
            </Text>
            <br />
          </>
        }
        action={
          <CustomButton
            htmlType="button"
            text="Generar nuevo certificado"
            onClick={onOpenForm}
          />
        }
      />
      <AjaxTable
        tableTitle="Listado de Certificaciones generales disponibles"
        columns={columns}
        endpoint={generalCertificatesTable}
        reloadSource={reloadSource}
        searchInput
        exportCSV
        reloadButton
      />
      <AddModal
        open={formOpen}
        onCancel={() => setFormOpen(false)}
        onFinish={onFinish}
      />

      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setPDFUrl(undefined)}
        open={pdfUrl}
      />
      <Link to={`${INTERNAL_LINKS.CONTRACTOR_CT_CERTIFICATIONS}`}>
        <CustomButton
          type={'default'}
          className={'back-button'}
          htmlType="button"
          text={'Volver'}
        />
      </Link>
    </>
  );
};

export default CTGeneralCertificationsContractor;
